<template>
  <div class="">
    <div v-if="usermapping === false">
      <div class="row">
        <div class="col">
          <div class="alert alert-warning">
            <div class="row">
              <div class="col-1 my-auto">
                <icon :icon="['fad', 'lock']" class="fa-3x"/>
              </div>
              <div class="col font-weight-bolder">
                Please enter the access code you received by email.<br>
                The code can only be entered once.<br>
                This links your abstract submission account with your e-poster uploads.
              </div>
              <div class="col my-auto">
                <div class="form-inline">
                  <div class="form-group">
                    <label for="tokenpw" class="sr-only">Your access code:&nbsp;</label>
                    <input type="password" id="tokenpw" v-model="token" required class="form-control mr-3"
                           aria-describedby="tokenHelp" @focus="error = ''" @keyup.enter="mapUserToken()"
                           placeholder="Access code">
                    <button class="btn btn-primary" v-on:click="mapUserToken()">
                      <icon :icon="['fad', 'lock-open']"/>&nbsp;Login
                    </button>
                  </div>
                </div>
                <div class="row" v-if="showError">
                  <div class="col">
                    <div class="alert alert-info">
                      <div class="row">
                        <div class="col-1">
                          <icon :icon="['fad', 'do-not-enter']" class="fa-2x"/>
                        </div>
                        <div class="col my-auto font-weight-bold" v-html="errorMsg"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card col p-0 d-flex mb-3" v-for="(submission, index) in submissions" v-bind:key="index">
      <h4 class="card-header">
        <div class="row">
          <div class="col d-flex">
            <div class="my-auto">
              {{ submission.name }}
            </div>
          </div>
          <div class="w-100 d-block d-sm-none"></div>
          <div class="col col-sm-4">
            <div class="smaller my-auto float-sm-right">
              <div class="mr-3">
                <span class="text-danger" v-if="!submission.isOpen"><icon :icon="['fad', 'lock']" class=""/> upload is closed</span>
                <span class="text-success" v-else><icon :icon="['fad', 'lock-open']"
                                                        class=""/> open</span>
              </div>
              <icon :icon="['fal', 'calendar-times']" class="text-danger"/>
              Deadline: {{ submission.show_stop_date | moment(wording[0].home.dateformat) }}
            </div>
          </div>
        </div>
      </h4>
      <div :id="'submission'+submission.id">
        <div class="card-body" v-if="posters">
          <Speaker :submission_id="submission.id" area="home"
                   textkey="guidelines"></Speaker>
          <div v-if="posters[submission.id]">
            <div class="list-group">
              <div class="list-group-item list-group-item-action p-2"
                   v-for="(poster, index) in posters[submission.id]"
                   v-bind:key="index">
                <div class="row d-flex">
                  <div class="col-6 col-sm-1 col-md-2 col-lg-1 my-auto mx-auto text-center"
                       v-if="poster.status_id === 1">
                    <icon :icon="['fad', 'envelope-open-text']" class="fa-2x"/>
                    <div class="text-warning">draft</div>
                  </div>
                  <div class="col-6 col-sm-1 col-md-2 col-lg-1 my-auto mx-auto text-center"
                       v-if="poster.status_id === 2">
                    <icon :icon="['fad', 'envelope']" class="fa-2x"/>
                    <div class="text-success">submit</div>
                  </div>
                  <div class="w-100 d-block d-sm-none"></div>
                  <div class="col my-auto">
                    <div class="my-auto" v-html="poster.title"></div>
                    <div class="small"><span v-if="poster.presentation_code">Pres. Code: {{ poster.presentation_code }}&nbsp;</span><span>ID: {{
                        poster.abstract_id
                      }}</span></div>
                  </div>
                  <div class="col-1 d-flex">
                    <router-link tag="button"
                                 :to="'poster/' + poster.id + '/dynamic/' + getFirstCurrentPage(submission.id).id"
                                 class="btn btn-link mx-auto"
                                 v-if="poster.status_id ===  1 && submission.isOpen">
                      <icon :icon="['fad', 'upload']" class="text-warning"/>
                      <br>
                      Upload
                    </router-link>
                    <button class="btn btn-link mx-auto"
                            v-else-if="poster.status_id ===  2">
                      <icon :icon="['fas', 'check']" class="text-success"/>
                      <br>Complete
                    </button>
                  </div>
                  <div class="col-1">
                    <router-link tag="button" class="btn btn-link mx-auto"
                                 :to="'poster/' + poster.id + '/submit'"
                                 v-if="poster.status_id === 1 && submission.isOpen">
                      <icon :icon="['fad', 'file-signature']"/>
                      <br>
                      {{ wording[0].buttons.submit }}
                    </router-link>
                    <router-link tag="button" class="btn btn-link mx-auto"
                                 :to="'poster/' + poster.id + '/preview'" v-else-if="poster.status_id >= 2">
                      <icon :icon="['fad', 'search']"/>
                      <br>
                      {{ wording[0].buttons.preview }}
                    </router-link>
                    <button class="btn btn-link disabled mx-auto" v-else>
                      <icon :icon="['fad', 'search']" class="disabled"/>
                      <br>
                      {{ wording[0].buttons.preview }}
                    </button>
                  </div>
                  <div class="col-1 d-flex">
                    <button class="btn btn-link mx-auto"
                            v-if="poster.status_id === 2 && submission.isOpen"
                            v-on:click="resetToEdit(poster.id)">
                      <icon :icon="['fad', 'undo']" class="text-warning"/>
                      <br>
                      Edit
                    </button>
                    <button class="btn btn-link disabled mx-auto" v-else>
                      <icon :icon="['fad', 'undo']" class="disabled"/>
                      <br>
                      Edit
                    </button>
                  </div>
                  <!--                  <div class="col-2 ml-auto">-->
                  <!--                    <button class="btn btn-link mx-auto" v-on:click="openAdditionalInfos(poster.id)">-->
                  <!--                      <icon :icon="['fad', 'qrcode']" class="text-warning"/>-->
                  <!--                      <br>-->
                  <!--                      Additional Info-->
                  <!--                    </button>-->
                  <!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="additionalInfoModal" tabindex="-1" role="dialog"
         aria-labelledby="additionalInfoModalTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="additionalInfoModalTitle">Additional Informations</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                If you have uploaded additional information during the upload, you can access it via this QR code or the
                link.<br>
                <br>
                The content above this link will only be released for the congress.
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <div class="input-group">
                  <input type="text" id="disabledTextInput" disabled="disabled" class="form-control"
                         :value="'https://wclh2020.abstractserver.com/paper/?id=' + cache.abstract_id">
                  <!--                  <div class="input-group-append">-->
                  <!--                    <button class="btn btn-outline-primary" type="button"-->
                  <!--                            v-on:click="copyAdditionalInfoUrl(cache.abstract_id)">-->
                  <!--                      <icon :icon="['fad', 'copy']" class=""/>-->
                  <!--                      Copy-->
                  <!--                    </button>-->
                  <!--                  </div>-->
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <button class="btn btn-primary mx-auto" v-on:click="GET_QR(cache.abstract_id)">
                  <icon :icon="['fad', 'qrcode']" class=""/>
                  Generate QR-Code
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-info" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex'
import Speaker from "../components/helpers/Speaker";

export default {
  components: {},
  computed: {
    ...mapState(['submissions', 'posters', 'user', 'usermapping', 'wording', 'processing', 'validation', 'cache']),
    ...mapGetters(['getFirstCurrentPage'])
  },
  methods: {
    ...mapActions(['GET_USERDATA', 'USER_CHECK_MAPPING', 'USER_UPDATE_MAPPING', 'RESET_POSTER', 'GET_QR']),
    ...mapMutations(['SET_USER', 'SET_USERMAPPING']),
    async checkUser() {
      if (!this.user.id) {
        await this.GET_USERDATA().then((result) => {
          this.SET_USER({user: result.data})
        })
      }
      await this.USER_CHECK_MAPPING(this.user.id).then((result) => {
        this.$set(this.$store.state, 'usermapping', true);
        this.getPosters();
      }).catch((error) => {
        this.$set(this.$store.state, 'usermapping', false);
      });
    },
    async mapUserToken() {
      this.errorMsg = '';
      this.showError = false;
      if (!this.token) {
        this.errorMsg = 'No access code entered.';
        this.showError = true;
        return false;
      }
      await this.USER_UPDATE_MAPPING({'token': this.token, 'user_id': this.user.id}).then((result) => {
        this.$set(this.$store.state, 'usermapping', true);
        this.getPosters();
        this.login.success = true;
        this.showError = false;
      }).catch((error) => {
        // this.token = null;
        this.errorMsg = 'Mapping was not successfull. <br> Please try again or contact the support.';
        this.showError = true;
      });
    },
    openAdditionalInfos(abstract_id) {
      this.$set(this.$store.state.cache, 'abstract_id', abstract_id);
      $('#additionalInfoModal').modal('show');
    },
    additionalInfoUrl(abstract_id) {
      return 'https://wclh2020.abstractserver.com/paper/?id=' + abstract_id;
    },
    resetToEdit(poster_id) {
      this.RESET_POSTER(poster_id).then((response) => {
        // this.$noty.success(this.wording[0].notify.save_success);
        this.$router.push('poster/' + poster_id + '/dynamic/' + this.getFirstCurrentPage(1).id);
        this.$noty.error("Your poster is not longer submitted. Please submit again!");
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.save_not_success);
      })
    },
    getPosters() {
      this.$store.dispatch('GET_POSTERS', 1);
    }
  },
  async created() {
    await this.checkUser();
    this.processing.validation = false;
    this.processing.dynamicdata = false;
    this.processing.rulex = false;

    this.validation.errors = [];
    this.validation.is_checked = false;
    this.validation.status = false;
  },
  data() {
    return {
      token: null,
      showError: false,
      errorMsg: ''
    };
  }
}
</script>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
